const homePath = process.env.VUE_APP_CDN_PATH || 'https://sacict.backend.ideavivat-demo.com';

console.log(`CDN Home Path: ${homePath}, ${process.env.VUE_APP_CDN_PATH}`);

export default {
  access(type: string, filename: string) {
    if (type === 'handicraft') return `${homePath}/images/handicraft/${filename}`;
    if (type === 'creator') return `${homePath}/images/creator/${filename}`;
    if (type === 'learningCenter') return `${homePath}/images/learning-center/${filename}`;
    if (type === 'floor-plan') return `${homePath}/images/floor-plan/${filename}`;
    if (type === 'media') return `${homePath}/images/media/${filename}`;
    if (type === 'knowledge') return `${homePath}/images/knowledge/${filename}`;
    if (type === 'magazine') return `${homePath}/documents/media/magazine/${filename}`;
    if (type === 'book') return `${homePath}/documents/media/book/${filename}`;
    return '';
  },
  accessByFolder(folder: string, filename: string) {
    return `${homePath}/images/${folder}/${filename}`;
  },
};
